<style lang="sass">
.custom-user-pop.el-popover
  margin-left: -85px
  width: 320px
  border: 1px solid #282729
  z-index: 2000!important
  .el-input
    input
      // text-align: center
      border: none
      padding-right: 0
  .el-tree-node__expand-icon
    position: absolute
    right: 0
  .popper__arrow
    display: none
</style>
<style lang="sass" scoped>
.pop-main
  ::v-deep .el-input
    width: 100%
    margin-bottom: 10px
    text-align: center
    border: 1px solid rgba(40,39,41,.2)
    input
      padding-left: 30px
          
  .list
    height: 360px
    overflow: auto
    overflow-x: hidden
    ::v-deep .el-checkbox
      position: relative
      top: -1px
    .none
      color: #999
      font-size: 12px
      text-align: center

    ::v-deep .el-radio
      display: block
      padding-left: 20px
      line-height: 30px
      color: #999
      &.is-checked
        color: #282729
        .el-radio__input
          .el-radio__inner
            border-color: #FF3973
            background: #FF3973
        .el-radio__label
          color: #282729

    ::v-deep .el-collapse-item__content
      padding-bottom: 10px

.coll-title
  i
    padding: 5px 8px
    background: #6296FF
    font-size: 12px
    margin-right: 10px
    color: #fff
    border-radius: 2px
    &.type1
      background: #FF3973
  .els
    display: inline-block
    width: 210px
    vertical-align: middle
    ::v-deep span
      color: #FF3973

.show_input
  height: 28px
  line-height: 28px
  overflow: hidden
  padding-left: 10px
  position: relative
  cursor: pointer
  > i
    position: absolute
    right: 10px
    top: 8px
    color: #c0c4cc
    line-height: 1
  .els
    max-width: 190px
    &.none
      color: #999

.el-collapse
  border-top: none
  border-bottom: none
</style>

<template lang="pug">
  el-popover(
    placement="bottom" trigger="click" popper-class="custom-user-pop"
    @hide="popHide" @show="popShow"
  )
    .show_input(slot="reference")
      .els.fl(:class="{ 'none': chooseDataStr === '请选择' }") {{ chooseDataStr }}
      i.el-icon-arrow-down(v-if="isHide")
      i.el-icon-arrow-up(v-else)

    .pop-main
      el-input(
        size="mini" v-model="searchName" placeholder="搜索客户名称" prefix-icon="el-icon-search"
        @focus="show = true; notSearch = false;" @blur="show = false; notSearch = true;"
      )
      .list(@scroll="listScroll")
        el-collapse(v-model="activeNames" @change="handleChange" accordion)
          el-collapse-item(v-for="(item, i) in customers" :key="item.id" :name="item.id")
            .coll-title(slot="title" :default="item")
              i(:class="{ 'type1': item.advertiserType === 2 }") {{ item.advertiserTypeName }}
              span.els(:title="item.customerName" v-html="item.customerNameHtml")
            .none(v-if="item.list && item.list.length === 0") 暂无用户
            el-radio(
              v-for="(user, i) in item.list" :key="user.id"
              v-model="radio" :label="user" name="user"
            ) {{ user.userName }}
        .none(v-if="!customers.length" style="margin-top: 10px;") 暂无数据
        .none(v-if="isNoMore" style="margin-top: 10px;") 没有更多了~

</template>

<script>
let customIdMap = {}
export default {
  name: 'CustomUser',
  props: [ 'text', 'v', 'parentProp' ],
  data () {
    return {
      searchName: '',
      show: false,
      notSearch: true,
      chooseDataStr: '请选择',
      isHide: true,
      searchTimer: null,
      customers: [],
      activeNames: '',
      page: {
        cur: 1, size: 10
      },
      isNoMore: false,
      isFetch: false,
      radio: null
    }
  },
  watch: {
    searchName (v) {
      v = v ? v.trim() : ''
      if (v.length > 100) {
        this.searchName = v.slice(0, 100)
        return
      }
      if (this.searchTimer) clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.isNoMore = false
        this.page.cur = 1
        this.getCustoms()
      }, 200)
    },
    activeNames (v) {
      // 点击客户展开触发
      // console.log('activeNames ',v);
    },
    radio (v) {
      this.chooseUser(v)
    },
    '$store.state.customer.userInfo': {
      immediate: true,
      handler (v) {
        // 默认选中当前用户
        this.chooseUser(v)
        this.radio = v
      }
    }
  },
  computed: {
    spread () {
      return data => data.length === 1 ? data[0].name : data.length + '个区'
    }
  },
  async created () {
    this.getCustoms()
  },
  methods: {
    chooseUser (v) {
      this.chooseDataStr = this.strSliceNum(v.customerName || '', 6) + '/' +  this.strSliceNum(v.userName)
      this.handlePkglist(v)
      this.$emit('change', v || {}, 'user')
    },
    init () {
      this.activeNames = ''
      this.radio = this.$store.state.customer.userInfo
      this.isNoMore = false
      this.searchName = ''
      this.page.cur = 1
      this.getCustoms()
      this.$emit('change', [], 'pkg')
      this.$emit('change', {}, 'user')
    },
    listScroll (e) {
      let dom = e.target
      if (dom.scrollHeight == dom.scrollTop + dom.clientHeight) this.getCustoms(true)
    },
    strSliceNum (str, num) {
      return str.length > num ? str.slice(0, num) + '...' : str
    },
    async getCustoms (isPush) { // 获取客户
      if (this.isNoMore) return
      if (this.isFetch) return
      this.isFetch = true

      let pSize = 20
      let opt = { 
        pageIndex : this.page.cur, pageSize: pSize,
        orderBy: 'asc', orderField: 'id', checkStatus: 1, userFilter: true
      }
      let searchName = this.searchName.trim()
      if (searchName) opt.customerName = searchName
      if (this.radio && [2000409, 2003128, 15127].indexOf(this.radio.id) > -1) { // 特殊用户仅能查看自身的客户数据
        opt.customerCode = this.radio.customerCode
      }

      let res = await this.fetch('/customer/api/v3/customers/page', opt, 'get')
      if (this.page.cur === 1) this.customers = []
      if (res && res.code == 0 && res.data) {
        let list = res.data.list || []
        if (this.customers.length && list.length < pSize) this.isNoMore = true
        else this.page.cur++
        let data = list.map(el => {
          customIdMap[el.id] = el
          let elName = el.customerName
          let showCName = this.strSliceNum(elName || '', 6)
          el.customerNameHtml = searchName ? elName.split(searchName).join(`<span>${searchName}</span>`) : elName
          // el.list = (el.children || []).map(ele => {
          //   let showUName = this.strSliceNum(ele.name || '', 3)
          //   return {
          //     ...ele, showStr: `${showCName}/${showUName}`, value: `${el.guid}-${ele.guid}`
          //   }
          // })
          return el
        })
        this.customers = isPush ? this.customers.concat(data) : data
      }
      this.$nextTick(() => {
        this.isFetch = false
      })
    },
    async getUsers (item) { // 获取用户, 直接size传2000 一次获取全部
      if (item && item.list && item.list.length) return
      let opt = { pageNum: 1, pageSize: 2000, customerCode: item.code, roleId: 0 }
      let res = await this.fetch('/customer/api/v3/users/page', opt, 'get')
      if (res && res.code == 0 && res.data) {
        let data = res.data.list || []
        item.list = data
        if (data.length && this.radio) { // 默认的数据勾选
          if (this.radio.customerId == item.id) {
            this.radio = data.filter(el => el.id == this.radio.id)[0]
          }
        }
      } else {
        item.list = []
      }
      this.$forceUpdate()
      console.log(item.list);
    },
    handleChange (id) {
      if (!id) return // 展开项收回
      this.getUsers(customIdMap[id])
    },
    async handlePkglist (item) { // 获取客户可用套餐码
      let id = item.id
      let res = await this.fetch(`/package/api/web/v2/customer-packages/${id}`, '', 'get')
      this.$emit('change', (res.data || []).map(el => {
        el.id = `${id}${el.packageName}`
        return el
      }), 'pkg')
    },
    popHide () {
      this.isHide = true
    },
    popShow () {
      this.isHide = false
      if (this.radio && this.radio.customerId) {
        this.customers.unshift(
          this.customers.splice(
            this.customers.map(el => el.id).indexOf(this.radio.customerId), 1
          )[0]
        )
      }
    }
  }
}
</script>